// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"689":"c72e044b","721":"17cc9e6e","799":"290560e9"}[chunkId] + ".chunk.css";
};